import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import CreateNewJobRoutings from './CreateNewJobRoutings';

import { initialState } from './reducer/createNewJobReducer';

// Actions
import extActions from './reducer/createNewLob.externalActions';
import { updateFilters } from './reducer/createNewJobActions';

const CreateNewJob = (props) => {
  const { campusesList, jobCampusId, jobPractitionerId, practitionersList, commonFilters, createNewJob, dispatch } = props;

  useEffect(() => {
    if (!campusesList) { dispatch(extActions.loadAndSaveCampusesList()); }
  }, [campusesList]);

  useEffect(() => {
    if (!practitionersList) { dispatch(extActions.loadAndSavePractitionersList()); }
  }, [practitionersList]);

  useEffect(() => {
    const { practitionerId, campusId } = commonFilters;
    if (practitionerId && !jobPractitionerId) { dispatch(updateFilters({ practitionerId })); }
    if (campusId && !jobCampusId) { dispatch(updateFilters({ campusId: campusId })); }
  }, [commonFilters, jobCampusId, jobPractitionerId]);

  // redirect to start screen if refresh page
  useEffect(() => {
    if (JSON.stringify(createNewJob) === JSON.stringify(initialState)
      && location.href.match(/new-job\//)) {
      dispatch(push('/practitioner/new-job'));
    }
  }, []);


  return (<CreateNewJobRoutings />);
};

const mapStateToProps = (store) => {
  const common = store.practitioner.common || {};
  const createJob = store.practitioner.createNewJob;
  return {
    campusesList: common.campusesList,
    commonFilters: common.commonFilters,
    createNewJob: createJob,
    jobCampusId: createJob.filters.campusId,
    jobPractitionerId: createJob.filters.practitionerId,
    practitionersList: common.practitionersList,
  };
};

export default connect(mapStateToProps)(CreateNewJob);
